const SEND_ERROR_COPY = Object.freeze({
    NOT_ISSUED: {
        key: 'forgotPassword.errors.notIssued',
        defaultValue: 'A verification code could not be sent. Check the account, channel, and communication provider.',
    },
    NO_CHANNEL: {
        key: 'forgotPassword.errors.noChannel',
        defaultValue: 'The selected verification channel is not enabled for this organization.',
    },
    NO_PROVIDER: {
        key: 'forgotPassword.errors.noProvider',
        defaultValue: 'A verification code could not be sent because no email or SMS provider is configured.',
    },
    INVALID_PROVIDER: {
        key: 'forgotPassword.errors.noProvider',
        defaultValue: 'A verification code could not be sent because no email or SMS provider is configured.',
    },
    DELIVERY_FAILED: {
        key: 'forgotPassword.errors.deliveryFailed',
        defaultValue: 'The verification code could not be sent through the communication provider. Check the provider settings.',
    },
    NO_PHONE: {
        key: 'forgotPassword.errors.noPhone',
        defaultValue: 'This account has no phone number for SMS.',
    },
    NO_EMAIL: {
        key: 'forgotPassword.errors.noEmail',
        defaultValue: 'This account has no email address.',
    },
    NO_TENANT: {
        key: 'forgotPassword.errors.noTenant',
        defaultValue: 'This account is not linked to an organization.',
    },
    COOLDOWN: {
        key: 'forgotPassword.errors.cooldown',
        defaultValue: 'Please wait before requesting another code.',
    },
});

const FALLBACK = Object.freeze({
    key: 'forgotPassword.errorMessage',
    defaultValue: 'Could not send the verification code. Please try again.',
});

/**
 * @param {string|null|undefined} code
 * @returns {{ key: string, defaultValue: string }}
 */
export function forgotPasswordSendErrorCopy(code) {
    return SEND_ERROR_COPY[code] || FALLBACK;
}

const GENERIC_API_CODES = new Set(['HTTP_ERROR', 'API_ERROR', 'UNKNOWN_ERROR']);

/**
 * @param {{ code?: string, details?: { code?: string } } | null | undefined} error
 * @returns {string}
 */
export function forgotPasswordErrorCodeFromApi(error) {
    const nested = error?.details?.code;
    const code = error?.code;
    if (code && !GENERIC_API_CODES.has(code)) return code;
    if (typeof nested === 'string' && nested) return nested;
    return 'DELIVERY_FAILED';
}
